import React, { useState, useEffect } from "react";

import cube from "services/cube";
import { Form, Loading } from "components";

export function Channels({ onChange, value }) {
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    cube
      .get("/list/channels")
      .then((response) => setChannels(response.data))
      .catch((error) => console.error(error));
  }, []);

  if (!channels.length) {
    return <Loading />;
  }

  return (
    <Form.Select
      isMulti
      placeholder="Todos"
      value={value}
      onChange={onChange}
      options={channels.map((channel) => ({
        value: channel.id,
        label: channel.name,
      }))}
    />
  );
}
